import { render, staticRenderFns } from "./UpdateUnitPhone.vue?vue&type=template&id=139ee794&scoped=true";
import script from "./UpdateUnitPhone.vue?vue&type=script&lang=js";
export * from "./UpdateUnitPhone.vue?vue&type=script&lang=js";
import style0 from "./UpdateUnitPhone.vue?vue&type=style&index=0&id=139ee794&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "139ee794", null);
export default component.exports;